// Chakra 
import { 
  Button,
  Flex, 
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text, 
} from '@chakra-ui/react';
import { textLang } from 'services/Lang';

const BalanceModal = ({handle, onOpen, isOpen, onClose}) => {
  return (
    	<> 
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent className="modal__simple" 
              maxW={{ base: '330px' }} 
              style={{ border:'1px solid #2ABDFD', overflow: 'hidden' }}>
                            
              <Box position="relative" p="40px 20px 24px 20px" bg='white !important' textAlign="center">
                  <Text variant="title-lg">
                    {textLang('match_user_balance')}
                  </Text>

                  <Flex mt="18px" gap="12px">
                    <Button variant="button-md" onClick={() => { handle(); onClose(); }}>{textLang('balance_top_up')}</Button>
                  </Flex>
              </Box>

          </ModalContent>
        </Modal> 
      </>
  );
};

export default BalanceModal;